import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { CMA_SUPPORT_URL } from '../apiConfig'

export const fetchTrail = createAsyncThunk(
  'fetchTrail',
  async ({ jwtBearer, ticket_number }) => {
    const response = await fetch(`${CMA_SUPPORT_URL}get/ticket/trail/?ticket_number=${ticket_number}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
      }
    })
    return response.json()
  }
)

const CMATrailSlice = createSlice({
  name: 'CMATrailSlice',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchTrail.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchTrail.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchTrail.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default CMATrailSlice.reducer
